<template>
  <div class="loginPage">
		<div class="loginComponent">
			<password-form
			:preselectTopic="preselectTopic"
			></password-form>
		</div>
  </div>
</template>

<script>

export default {
	name: 'PasswordPage',
	props: {
		preselectTopic: String
	},
	metaInfo: {
		title: 'Change Password'
	}
}
</script>
<style>
</style>
